module.exports = __webpack_public_path__ + "img/cover-appeau.d7d6bd61.jpg";